<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="nome"
              rules="required"
            >
              <b-form-group label="Nome" label-for="v-name">
                <b-form-input
                  id="v-name"
                  v-model="form.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="nome"
                  :disabled="
                    (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') &&
                      !!form.id) ||
                    (!verificarPermissao('ROLE_ADMIM_INSERIR') && !form.id)
                  "
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" md="12" lg="12">
            <validation-provider
              #default="{ errors }"
              name="Tipo Evento"
              rules="required"
            >
              <b-form-group label="Tipo Evento" label-for="v-tipoEvento">
                <v-select
                  v-model="form.tipoEvento.id"
                  :reduce="(comboTipoEvento) => comboTipoEvento.id"
                  label="nome"
                  :options="comboTipoEvento"
                  :state="errors.length > 0 ? false : null"
                  data-cy="tipo"
                  :disabled="
                    (!verificarPermissao('ROLE_ATEND_ATUALIZAR') &&
                      !!form.id) ||
                    (!verificarPermissao('ROLE_ATEND_INSERIR') && !form.id)
                  "
                />
                <small data-cy="v-especialidade" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" md="6" lg="12">
            <validation-provider
              #default="{ errors }"
              name="Tipo Campo"
              rules="required"
            >
              <b-form-group label="Tipo Campo" label-for="v-tipoCampo">
                <v-select
                  v-model="form.tipoCampo"
                  :options="comboTipoCampo"
                  :reduce="(comboProcedimentos) => comboProcedimentos.value"
                  :state="errors.length > 0 ? false : null"
                  data-cy="tipoCampo"
                  :disabled="
                    (!verificarPermissao('ROLE_ATEND_ATUALIZAR') &&
                      !!form.id) ||
                    (!verificarPermissao('ROLE_ATEND_INSERIR') && !form.id)
                  "
                />
                <small data-cy="v-tipoCampo" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" md="6" lg="12">
            <validation-provider
              #default="{ errors }"
              name="Ordem"
              rules="required"
            >
              <b-form-group label="Ordem" label-for="v-ordem">
                <b-form-input
                  id="v-ordem"
                  v-model="form.ordem"
                  :state="errors.length > 0 ? false : null"
                  placeholder="ordem"
                  :disabled="
                    (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') &&
                      !!form.id) ||
                    (!verificarPermissao('ROLE_ADMIM_INSERIR') && !form.id)
                  "
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" sm="6" md="6" lg="6">
            <validation-provider
              #default="{ errors }"
              name="Obrigatório"
              rules="required"
            >
              <b-form-group label="Obrigatório" label-for="v-obrigatorio">
                <b-form-checkbox
                  v-model="form.obrigatorio"
                  :checked="form.obrigatorio"
                  name="check-button"
                  switch
                  inline
                  :disabled="
                    (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') &&
                      !!form.id) ||
                    (!verificarPermissao('ROLE_ADMIM_INSERIR') && !form.id)
                  "
                >
                  {{ form.obrigatorio ? "Sim" : "Não" }}
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col v-if="form.id" cols="12" md="6" lg="6">
            <b-form-group label="Ativo" label-for="v-ativo">
              <b-form-checkbox
                v-model="form.ativo"
                :checked="form.ativo"
                name="check-button"
                switch
                inline
                :disabled="
                  (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') && !!form.id) ||
                  (!verificarPermissao('ROLE_ADMIM_INSERIR') && !form.id)
                "
              >
                {{ form.ativo ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
        </b-row>
        <b-row cols="12">
          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_ADMIM_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_ADMIM_ATUALIZAR')"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import mixinsGlobal from "@/mixins";
import vSelect from "vue-select";
import { verificarPermissao } from "@/auth/utils";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState("eventTypeFieldSettingsModule", {
      eventTypeField: (state) => state.eventTypeField,
    }),
    ...mapState("combosModule", {
      comboTipoEvento: (state) => state.comboTipoEvento,
    }),
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    vSelect,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      verificarPermissao,
      titleForm: "Cadastro de Campo Tipo de Evento",
      required,
      form: {
        nome: "",
        tipoEvento: {
          id: "",
        },
        tipoCampo: "",
        obrigatorio: false,
        ordem: 0,
        ativo: true,
      },
      comboTipoCampo: [
        {
          value: "STRING",
          label: "Texto",
        },
        {
          value: "TEXTO",
          label: "Area para Texto",
        },
        {
          value: "NUMBER",
          label: "Número",
        },
        {
          value: "DECIMAL",
          label: "Decimal, Ex: 10.50",
        },
        {
          value: "DATA",
          label: "Data",
        },
        {
          value: "BOOLEAN",
          label: "Verdadeiro ou Falso",
        },
      ],
    };
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.eventTypeField));
    this.$store.dispatch("combosModule/loadComboTipoEvento");
  },
  methods: {
    cancel() {
      this.$emit("cancelar");
      this.cleanObjeto();
      this.$store.dispatch("eventTypeFieldSettingsModule/reset");
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch("eventTypeFieldSettingsModule/edit", this.form)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    "Falha ao Editar",
                    response.response.data.error
                  );
                  return;
                }
                this.showMessageSuccess("Editar", "Editado com sucesso!");
                this.$refs.form.reset();
                this.cancel();
              });
          } else {
            this.$store
              .dispatch("eventTypeFieldSettingsModule/insertNew", this.form)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    "Falha ao Inserir",
                    response.response.data.error
                  );
                  return;
                }
                this.showMessageSuccess("Salvo", "Incluido com sucesso!");
                this.cleanObjeto();
                this.$store.dispatch("eventTypeFieldSettingsModule/reset");
                this.$refs.form.reset();
              });
          }
        }
      });
    },
    cleanObjeto() {
      this.form = {
        nome: "",
        tipoEvento: {
          id: "",
        },
        tipoCampo: "",
        obrigatorio: false,
        ordem: 0,
        ativo: true,
      };
    },
  },
};
</script>
